import React, { useState } from "react";

export default function PoliceVerificationPopup({
  showModal,
  selectedRow,
  handleFileChange,
  handleUpload,
  setShowModal,
  error
}) {
  if (!showModal) return null;


  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">

            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title">
                Police Verification Document
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                style={{padding: '5px'}}
              >X</button>
            </div>

            {/* Body */}
            <div className="modal-body">

              
                <>
                <div className="filtercont">
                  <div className="row">
                    <div className="col-md-9">
                        <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={handleFileChange}
                        />
                        <p className="text-danger">{error}</p>
                      </div>
                      <div className="col-md-3">
                      <button
                        className="btn btn-default submit sitebtn px-3" style={{float:'right'}}
                        onClick={handleUpload}
                      >
                        Upload
                      </button>
                      </div>
                  </div>
                  </div>
                </>
              

            </div>

            

          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
